<template>
    <div class="box kejin">
        <p class="title">アイテム購入時に問題が発生した</p>
        <div class="formWrap">
            <el-form
                ref="kejin"
                :rules="kejinRules"
                :label-position="labelPosition"
                :model="kejinForm"
                label-width="250px"
            >
                <el-form-item label="プレイヤー名" prop="name">
                    <el-input v-model="kejinForm.name"></el-input>
                </el-form-item>
                <el-form-item label="プレイヤーID" prop="friendID">
                    <el-input v-model="kejinForm.friendID"></el-input>
                    <span class="tip">※友人検索画面右上に表示</span>
                </el-form-item>
                <el-form-item label="メールアドレス" prop="email">
                    <el-input v-model="kejinForm.email"></el-input>
                </el-form-item>
                <el-form-item class="required" label="メールアドレス（確認）" prop="reemail">
                    <el-input v-model="kejinForm.reemail"></el-input>
                </el-form-item>
                <el-form-item label="現在の状況" prop="curStatus">
                    <el-select v-model="kejinForm.curStatus" placeholder="選んでください">
                        <el-option
                            v-for="item in curStatusoptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="購入した日時" prop="buytime">
                    <el-date-picker
                        v-model="kejinForm.buytime"
                        type="date"
                        value-format="timestamp"
                        placeholder="日付を選択"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="支払い方法" prop="buytype">
                    <el-select v-model="kejinForm.buytype" placeholder="選んでください">
                        <el-option
                            v-for="item in buyTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="購入情報" prop>
                    <el-upload
                        action="/"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-exceed="handleExceed"
                        :on-change="handleChange"
                        :auto-upload="false"
                        multiple
                        :limit="3"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary">クリックしてアップロード</el-button>
                        <div slot="tip" class="el-upload__tip">
                            ※注文番号、日付、合計金額、購入アイテム、単価を確認できるように撮影をお願いいたします。
                            <br>※1週間以内に同アイテムで複数の履歴がある場合には、全てお送りください。
                            <br>※画像はひとつ4MB以内でお願いします。
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 5}"
                        v-model="kejinForm.content"
                    ></el-input>
                </el-form-item>
                <el-form-item class="required" label="個人情報の取り扱いについて" prop="perChecked">
                    <el-checkbox v-model="kejinForm.perChecked">同意する</el-checkbox>
                    <a
                        class="checked"
                        target="_blank"
                        href="https://mahjongsoul.com/privacy_policy"
                    >※プライバシーポリシーをご確認ください。</a>
                </el-form-item>
                <el-form-item label>
                    <el-button size="medium" type="info" plain @click="kejinConfirm">上記内容で送信</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: "kejin",
    data() {
        // kejin 自定义表单验证规则
        const kejin_reemail = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("もう一度メールアドレスを入力してください"));
            } else if (value !== this.kejinForm.email) {
                callback(new Error("メールアドレスが一致しません"));
            } else {
                callback();
            }
        };

        const kejin_content = (rule, value, callback) => {
            if (value === "" && this.kejinForm.curStatus == 2) {
                callback(new Error("必須"));
            } else {
                callback();
            }
        };

        const kejin_perChecked = (rule, value, callback) => {
            if (!value) {
                callback(new Error("同意してください"));
            } else {
                callback();
            }
        };

        return {
            labelPosition: "right",

            // kejin
            kejinForm: {
                name: "",
                friendID: "",
                email: "",
                reemail: "",
                curStatus: "",
                buytime: "",
                buytype: "",
                content: "",
                perChecked: false
            },
            fileList: [],
            curStatusoptions: [
                {
                    value: "1",
                    label: "購入したアイテムが反映されていない"
                },
                {
                    value: "2",
                    label: "その他お困りのこと（具体的な問題を「内容」にお書きください）"
                }
            ],
            buyTypeOptions: [
                {
                    value: "1",
                    label: "クレジットカード"
                },
                {
                    value: "2",
                    label: "Paypal(ペイパル）"
                },
                {
                    value: "3",
                    label: "ドコモ払い"
                },
                {
                    value: "4",
                    label: "ソフトバンクまとめて支払い"
                },
                {
                    value: "5",
                    label: "auかんたん決済"
                }
            ],
            kejinRules: {
                name: [
                    {
                        required: true,
                        message: "必須",
                        trigger: "blur"
                    }
                ],
                friendID: [
                    { required: true, message: "必須", trigger: "blur" }
                ],
                email: [
                    {
                        required: true,
                        message: "必須",
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: "正しいメールアドレスを入力してください",
                        trigger: ["blur", "change"]
                    }
                ],
                reemail: [
                    {
                        trigger: "blur",
                        validator: kejin_reemail
                    }
                ],
                curStatus: [
                    { required: true, message: "必須", trigger: "change" }
                ],
                buytime: [
                    {
                        type: "date",
                        required: true,
                        message: "必須",
                        trigger: "change"
                    }
                ],
                content: [
                    {
                        trigger: "blur",
                        validator: kejin_content
                    }
                ],
                perChecked: [
                    {
                        trigger: "change",
                        validator: kejin_perChecked
                    }
                ]
            }
        };
    },
    created() {
        if (!this.$utils.isPC()) {
            this.labelPosition = "top";
        }
    },
    methods: {
        mapOptionsLable(options, value) {
            for (let i = 0, len = options.length; i < len; i++) {
                if (options[i].value == value) {
                    return options[i].label;
                }
            }
        },
        handlePreview(file) {
            console.log("handlePreview :", file);
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        handleExceed(files, fileList) {
            console.log(files, fileList);
            this.$message.warning(
                `当前限制选择 3 个文件，本次选择了 ${
                    files.length
                } 个文件，共选择了 ${files.length + fileList.length} 个文件`
            );
        },
        handleChange(files, fileList) {
            if (files.raw.type.indexOf("image") == -1) {
                this.$message.warning("画像をアップロードしてください");
                fileList.splice(
                    fileList.findIndex(item => item.uid == files.uid),
                    1
                );
            } else if (files.size / 1024 / 1024 > 4) {
                this.$message.warning("画像はひとつ4MB以内でお願いします");
                fileList.splice(
                    fileList.findIndex(item => item.uid == files.uid),
                    1
                );
            } else {
                this.fileList = fileList;
            }
        },
        kejinConfirm() {
            this.$refs["kejin"].validate(valid => {
                if (!valid) {
                    return false;
                } else {
                    if(confirm('ご入力いたたいた内容で送信してよろしいでしょうか？')) {
                        this.confirm();
                    } else {
                        return false;
                    }
                }
            });
        },
        confirm() {
            let formData = new FormData();
            formData.set("name", this.kejinForm.name);
            formData.set("friendID", this.kejinForm.friendID);
            formData.set("email", this.kejinForm.email);
            formData.set(
                "curStatus",
                this.mapOptionsLable(
                    this.curStatusoptions,
                    this.kejinForm.curStatus
                )
            );
            formData.set("buytime", this.kejinForm.buytime);
            formData.set(
                "buytype",
                this.mapOptionsLable(
                    this.buyTypeOptions,
                    this.kejinForm.buytype
                )
            );
            formData.set("content", this.kejinForm.content);
            // 氪金
            formData.set("type", "1");
            formData.set("title", "アイテム購入時に問題が発生した");

            for (let i = 0, len = this.upFileList.length; i < len; i++) {
                formData.append("fileList", this.upFileList[i]);
            }

            this.$message({
                message:'送信が成功',
                duration: 10000
            });

            this.axios
                .post("/service/dismail", formData)
                .then(v => {
                    console.log(v);
                    if (v.data.retcode == 1) {
                        // 清空表单
                        /* this.kejinForm.name = "";
                        this.kejinForm.friendID = "";
                        this.kejinForm.email = "";
                        this.kejinForm.reemail = "";
                        this.kejinForm.curStatus = "";
                        this.kejinForm.buytime = "";
                        this.kejinForm.buytype = "";
                        this.kejinForm.content = "";
                        this.perChecked.perChecked = false;
                        this.fileList = []; */
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        }
    },
    computed: {
        upFileList() {
            let _fileList = [];
            for (let i = 0, len = this.fileList.length; i < len; i++) {
                _fileList.push(this.fileList[i].raw);
            }
            return _fileList;
        }
    }
};
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    color: #fff;

    & ::v-deep .el-button {
        background: transparent;
    }

    .title {
        width: 100%;
        background: #000;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(50px);
        .back {
            font-size: pxTorem(24px);
            cursor: pointer;
        }
    }
    .formWrap {
        width: 80%;
        margin: 0 auto;
        box-sizing: border-box;
        padding: pxTorem(10px) pxTorem(20px);

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        & ::v-deep .el-form-item__label {
            color: #fff;
        }
        & ::v-deep .el-input__inner {
            color: #fff;
        }
        & ::v-deep .el-textarea__inner {
            background: transparent;
            color: #fff;
            font-family: $japaneseFontFamily;
            &::-webkit-scrollbar {
                width: 10px;
            }
            &::-webkit-scrollbar-track {
                background-color: #001238;
                border-radius: 8px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #407cfd;
                border-radius: 8px;
            }
        }
        .tip {
            font-size: pxTorem(10px);
            color: #afafaf;
        }
        .checked {
            color: #ac7f00;
        }
        .el-upload__tip {
            color: #afafaf;
            line-height: 1.5;
        }
        & ::v-deep .el-upload-list__item {
            height: auto !important;
            border: 1px solid transparent;
        }
        & ::v-deep .el-upload-list__item:hover {
            background: transparent;
            border: 1px solid #fff;
        }
        & ::v-deep .el-upload-list__item-name {
            color: #fff;
        }
        & ::v-deep .el-icon-document {
            color: #fff;
        }
        & ::v-deep .el-icon-close {
            color: #fff;
        }
    }
}
</style>
